import type { TranslateMapConfig } from '@urc-ui/hooks/translate-map';
import { PRESET_PERIOD } from './types';
import { getTimezone } from '@urc-ui/services/app-context';
import { formatInTimeZone } from 'date-fns-tz';
import dt from '@urc-ui/components/date-input/utils/date-time-fns';
import { isAfter } from 'date-fns';

export const PRESET_PERIOD_TRANSLATION_MAP: TranslateMapConfig = {
  [PRESET_PERIOD.TODAY]: {
    id: 'sspa_rcm_ad_reports_date_presets_today',
    default: 'Today'
  },
  [PRESET_PERIOD.YESTERDAY]: {
    id: 'sspa_rcm_ad_reports_date_presets_yesterday',
    default: 'Yesterday'
  },
  [PRESET_PERIOD.LAST_7_DAYS]: {
    id: 'sspa_rcm_ad_reports_date_presets_last_seven_days',
    default: 'Last 7 days'
  },
  [PRESET_PERIOD.THIS_WEEK]: {
    id: 'sspa_rcm_ad_reports_date_presets_week_to_date',
    default: 'Week to date'
  },
  [PRESET_PERIOD.WEEK_TO_DATE]: {
    id: 'sspa_rcm_ad_reports_date_presets_week_to_date',
    default: 'Week to date'
  },
  [PRESET_PERIOD.LAST_WEEK]: {
    id: 'sspa_rcm_ad_reports_date_presets_last_week',
    default: 'Last week'
  },
  [PRESET_PERIOD.LAST_14_DAYS]: {
    id: 'sspa_rcm_ad_reports_date_presets_last_fourteen_days',
    default: 'Last 14 days'
  },
  [PRESET_PERIOD.THIS_MONTH]: {
    id: 'sspa_rcm_ad_reports_date_presets_month_to_date',
    default: 'Month to date'
  },
  [PRESET_PERIOD.MONTH_TO_DATE]: {
    id: 'sspa_rcm_ad_reports_date_presets_month_to_date',
    default: 'Month to date'
  },
  [PRESET_PERIOD.LAST_30_DAYS]: {
    id: 'sspa_rcm_ad_reports_date_presets_last_thirty_days',
    default: 'Last 30 Days'
  },
  [PRESET_PERIOD.LAST_MONTH]: {
    id: 'sspa_rcm_ad_reports_date_presets_last_month',
    default: 'Last month'
  }
};

export const DEFAULT_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric'
};

export const DEFAULT_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric'
};

/**
 * Formats the given timezone into three letter zone EST/PST/IST format.
 * @param timestamp - the epoch timestamp
 */
export const formatTimezone = (timestamp: number) => {
  return formatInTimeZone(timestamp, getTimezone(), 'z');
};

/**
 * Return the maximum allowed date in the given time zone. If the reportingWindow
 * is specified this will be min(today, startDateZoned+reportingWindow-1), if not
 * it will be today.
 * @param todayUtc
 * @param timeZone
 * @param startDateUtc
 * @param reportingWindow
 */
export const getMaxDateUtc = (todayUtc: Date, timeZone: string, startDateUtc?: Date, reportingWindow?: number) => {
  if (!startDateUtc || reportingWindow === undefined || reportingWindow <= 0) {
    return todayUtc;
  }

  const maxDateUtc = startDateUtc ? dt.addDays(reportingWindow - 1)(startDateUtc) : todayUtc;
  return isAfter(maxDateUtc, todayUtc) ? todayUtc : maxDateUtc;
};

export const isValidDate = (d: unknown) => {
  return d instanceof Date && !isNaN(d.getTime());
};
